import { Grid, useMediaQuery, useTheme } from '@mui/material'
import SummaryCard from 'components/SummaryCard/SummaryCard'
import React from 'react'

const OrderSummary = ({ orderSummary, customGridSize }) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"))

  // Default grid sizing if not provided
  const defaultGridSize = { xs: 6, sm: 6, md: 3 };
  const gridSize = customGridSize || defaultGridSize;

  return (
    <Grid className='order-summary-container' container spacing={{ xs: 1, sm: 2 }} sx={{ ml: 0 }}>
      {orderSummary?.map((item) => (
        <Grid item {...gridSize} key={item.id}>
          <SummaryCard
            item={item}
            isSmall={isSmall}
            theme={theme}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default OrderSummary
